import VueAxios from "vue-axios";
import axios from "axios";
//Vue.use(VueAxios, axios);
//Vue.use(Vuex)
//const this.$store.state.baseapi = "http://127.0.0.1:8000/api/";
export default {
    data() {
      return {
       
      }
    },
  
    created() {
     
    },
  
    methods: {
     
      GET_PMD_ARBOLES_PROBLEMA: async function(data) {




      
        var result =  await axios
          ({
            method: 'GET',
            url: this.$store.state.baseapi+"sistema_municipios/"+data.idmunicipio+"/dependencias/"+data.idsecretaria+"/departamentos/"+data.iddepartamento+"/arbol/" ,
            responseType: 'json',
            headers: {
          
              "Content-Type": "application/json",
              'X-Authorization': 'Bearer ' +this.$store.state.user.token
  
            },
              
            }
            
          )
          .then(
            response => {
           
              //context.commit('SET_USER_DEALS', { deals: response.data.data })
              return response.data;
            },
            err => {
              
              return null;
            }
          );
          return result;
  
  
  
  
  
      },
  
      GET_PMD_ARBOLES: async function(data) {

        var result =  await axios
          ({
            method: 'GET',
            url: this.$store.state.baseapi+"sistema_municipios/"+data.idmunicipio+"/arboles/" ,
            responseType: 'json',
            headers: {
          
              "Content-Type": "application/json",
              'X-Authorization': 'Bearer ' +this.$store.state.user.token
  
            },
              
            }
            
          )
          .then(
            response => {
           
              //context.commit('SET_USER_DEALS', { deals: response.data.data })
              return response.data;
            },
            err => {
              
              return null;
            }
          );
          return result;
  
  
      },
        GET_PMDID_ARBOLES: async function(data) {




      
        var result =  await axios
          ({
            method: 'GET',
            url: this.$store.state.baseapi+"pmd_arboles_problema/"+data.id ,
            responseType: 'json',
            headers: {
          
              "Content-Type": "application/json",
              'X-Authorization': 'Bearer ' +this.$store.state.user.token
  
            },
              
            }
            
          )
          .then(
            response => {
           
              //context.commit('SET_USER_DEALS', { deals: response.data.data })
              return response.data;
            },
            err => {
              
              return null;
            }
          );
          return result;
  
  
  
  
  
      },
      EDITAR_PMD_ARBOLES_PROBLEMA: async function(data) {



      
        var result =  await axios
          ({
            method: 'PUT',
            url: this.$store.state.baseapi+"pmd_arboles_problema/"+data.id ,
            responseType: 'json',
            headers: {
          
              "Content-Type": "application/json",
              'X-Authorization': 'Bearer ' +this.$store.state.user.token
  
            },
            data:{
            //QUITAR COMILLAS SOLO EN DATA 
            //'idmunicipio','idsecretaria','iddepartamento','identificacion','problema', 'efectos', 'causas', 
            
            idsecretaria:data.idsecretaria,
            iddepartamento:data.iddepartamento,
               identificacion:data.identificacion,
               problema:data.problema, 
                efectos:data.efectos, 
                 causas:data.causas, 
            
           
       
            }
              
            }
            
          )
          .then(
            response => {
           
              //context.commit('SET_USER_DEALS', { deals: response.data.data })
              return response.data;
            },
            err => {
              
              return null;
            }
          );
          return result;
  
  
  
  
  
      },
  
  
  





    CREAR_PMD_ARBOLES_PROBLEMA: async function(data) {



      
      var result =  await axios
        ({
          method: 'POST',
          url: this.$store.state.baseapi+"pmd_arboles_problema/" ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
          data:{
          //QUITAR COMILLAS SOLO EN DATA 
          //'idmunicipio','idsecretaria','iddepartamento','identificacion','problema', 'efectos', 'causas', 
          idsecretaria:data.idsecretaria,
           
          iddepartamento:data.iddepartamento,
             identificacion:data.identificacion,
             problema:data.problema, 
              efectos:data.efectos, 
               causas:data.causas, 
          
     
          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },




  }
}